// src/components/About.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

const About = () => {
  const [currentLanguage, setCurrentLanguage] = useState('english');
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);


  const navigate = useNavigate();


  const translations = {
    english: {
      // Header
      logo: 'FinLink',
      navHome: 'Home',
      navServices: 'Services',
      navAbout: 'About us',
      navDsa: 'Become Partner',
      navFaq: 'FAQ',
      navContact: 'Contact',
      navCareer: 'Career with us',
      navHelp: 'Help Desk',
      partnerButton: 'Login',
      applyButton: 'Become DSA',

      // Page Content
      pageTitle: "About Krishna Finconcept Services",
      heroTitle: "India's Leading Loan & Financial Services Platform",
      heroSubtitle: "Empowering Dreams Through Financial Solutions",

      missionTitle: "Our Mission",
      missionContent: "To democratize access to financial services by leveraging technology, simplifying processes, and building lasting relationships with our customers and partners.",

      visionTitle: "Our Vision",
      visionContent: "To become the most trusted financial partner for every Indian, enabling financial freedom and prosperity through innovative solutions.",

      valuesTitle: "Our Values",
      value1Title: "Customer First",
      value1Desc: "We put our customers at the center of everything we do, ensuring their financial needs are met with integrity and excellence.",
      value2Title: "Innovation Driven",
      value2Desc: "Continuously evolving our technology and processes to provide cutting-edge financial solutions.",
      value3Title: "Transparency",
      value3Desc: "Clear communication, honest dealings, and complete transparency in all our operations.",
      value4Title: "Partnership",
      value4Desc: "Building strong relationships with banks, financial institutions, and DSA partners for mutual growth.",
      value5Title: "Excellence",
      value5Desc: "Striving for perfection in every service we offer, setting new standards in the financial industry.",
      value6Title: "Social Responsibility",
      value6Desc: "Contributing to society by making financial services accessible to all sections of the population.",

      journeyTitle: "Our Journey",
      journey1Year: "2010",
      journey1Title: "Foundation",
      journey1Desc: "Started with a vision to simplify loan processes for common people.",
      journey2Year: "2014",
      journey2Title: "Expansion",
      journey2Desc: "Expanded to 5 major cities with 50+ banking partners.",
      journey3Year: "2018",
      journey3Title: "Digital Transformation",
      journey3Desc: "Launched our digital platform, serving 1000+ customers monthly.",
      journey4Year: "2022",
      journey4Title: "National Presence",
      journey4Desc: "Covered 4000+ cities across India with 250+ banking partners.",
      journey5Year: "2024",
      journey5Title: "Market Leadership",
      journey5Desc: "Became India's fastest growing financial services platform.",

      achievementsTitle: "Our Achievements",
      achievement1Title: "50000+",
      achievement1Desc: "Satiesfied Customers",
      achievement2Title: "250+",
      achievement2Desc: "Banking Partners",
      achievement3Title: "28+",
      achievement3Desc: "Years Combined Experience",
      achievement4Title: "4000+",
      achievement4Desc: "Cities Served",

      leadershipTitle: "Leadership Team",
      ceoName: "Mr. Rakesh Panchal",
      ceoRole: "Founder & CEO",
      ceoBio: "With over 28 years of experience in the financial sector, Mr. Panchal has revolutionized the loan distribution industry with his visionary leadership.",
      ctoName: "Ms. Priya Sharma",
      ctoRole: "Chief Technology Officer",
      ctoBio: "Leading our digital transformation with 15+ years experience in fintech innovation and secure platform development.",
      cfoName: "Mr. Amit Verma",
      cfoRole: "Chief Financial Officer",
      cfoBio: "Expert in financial management with 20+ years of experience in banking and financial services.",

      whyChooseTitle: "Why Choose Krishna Finconcept Services?",
      reason1Title: "Wide Network",
      reason1Desc: "Access to 250+ banks and NBFCs across India.",
      reason2Title: "Best Rates",
      reason2Desc: "Guaranteed best interest rates through our partner network.",
      reason3Title: "Fast Processing",
      reason3Desc: "Quick loan approval and disbursal within 24-72 hours.",
      reason4Title: "Digital Experience",
      reason4Desc: "Complete digital journey from application to disbursal.",
      reason5Title: "Expert Guidance",
      reason5Desc: "Dedicated relationship managers for personalized assistance.",
      reason6Title: "Transparent Process",
      reason6Desc: "No hidden charges, complete fee disclosure upfront.",

      footerAbout: 'Krishna Finconcept Services',
      footerDescription: 'India\'s leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.',
      footerProducts: 'Loan Products',
      footerHome: 'Home Loan',
      footerPersonal: 'Personal Loan',
      footerBusiness: 'Business Loan',
      footerLap: 'Loan Against Property',
      footerCar: 'Car Loan',
      footerEducation: 'Education Loan',
      footerServices: 'Other Services',
      footerCredit: 'Credit Cards',
      footerInsurance: 'Insurance',
      footerGold: 'Gold Loan',
      footerBills: 'Bill Payments',
      footerCreditScore: 'Free Credit Score',
      footerPartner: 'Become Partner',
      footerContact: 'Contact Us',
      footerPhone: '9909002220',
      footerEmail: 'krishnafinconcept09@gmail.com',
      footerAddress: 'Available in 4,000+ cities across India',
      footerTiming: 'Mon-Sat: 9AM-9PM | Sun: 10AM-6PM',
      copyrightText: '© 2025 Krishna Finconcept Services Financial Services. All rights reserved.',
      privacyLink: 'Privacy Policy',
      termsLink: 'Terms & Conditions',
      disclaimerLink: 'Disclaimer'
    },
    hindi: {
      // Header
      logo: 'फिनलिंक',
      navHome: 'होम',
      navServices: "सेवाएं",
      navAbout: 'हमारे बारे में',
      navDsa: 'भागीदार बनें',
      navFaq: 'सामान्य प्रश्न',
      navContact: 'संपर्क करें',
      navCareer: 'करियर हमारे साथ',
      navHelp: 'हेल्प डेस्क',
      partnerButton: 'लॉगिन',
      applyButton: 'डीएसए बनें',

      // Page Content
      pageTitle: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज के बारे में',
      heroTitle: "भारत का अग्रणी ऋण और वित्तीय सेवा प्लेटफॉर्म",
      heroSubtitle: "वित्तीय समाधानों के माध्यम से सपनों को सशक्त बनाना",

      missionTitle: 'हमारा मिशन',
      missionContent: 'प्रौद्योगिकी का लाभ उठाकर, प्रक्रियाओं को सरल बनाकर और हमारे ग्राहकों और भागीदारों के साथ स्थायी संबंध बनाकर वित्तीय सेवाओं तक पहुंच को लोकतांत्रिक बनाना।',

      visionTitle: 'हमारी दृष्टि',
      visionContent: 'नवीन समाधानों के माध्यम से वित्तीय स्वतंत्रता और समृद्धि को सक्षम करते हुए प्रत्येक भारतीय के लिए सबसे विश्वसनीय वित्तीय भागीदार बनना।',

      valuesTitle: 'हमारे मूल्य',
      value1Title: 'ग्राहक प्रथम',
      value1Desc: 'हम अपने ग्राहकों को हर चीज के केंद्र में रखते हैं, यह सुनिश्चित करते हुए कि उनकी वित्तीय जरूरतों को ईमानदारी और उत्कृष्टता के साथ पूरा किया जाए।',
      value2Title: 'नवाचार संचालित',
      value2Desc: 'अत्याधुनिक वित्तीय समाधान प्रदान करने के लिए लगातार हमारी तकनीक और प्रक्रियाओं का विकास करना।',
      value3Title: 'पारदर्शिता',
      value3Desc: 'स्पष्ट संचार, ईमानदारी से लेन-देन, और हमारे सभी संचालन में पूरी पारदर्शिता।',
      value4Title: 'साझेदारी',
      value4Desc: 'पारस्परिक विकास के लिए बैंकों, वित्तीय संस्थानों और डीएसए भागीदारों के साथ मजबूत संबंध बनाना।',
      value5Title: 'उत्कृष्टता',
      value5Desc: 'हम जो भी सेवा प्रदान करते हैं उसमें पूर्णता के लिए प्रयास करना, वित्तीय उद्योग में नए मानक स्थापित करना।',
      value6Title: 'सामाजिक जिम्मेदारी',
      value6Desc: 'जनसंख्या के सभी वर्गों के लिए वित्तीय सेवाओं को सुलभ बनाकर समाज में योगदान देना।',

      journeyTitle: 'हमारी यात्रा',
      journey1Year: '2010',
      journey1Title: 'स्थापना',
      journey1Desc: 'आम लोगों के लिए ऋण प्रक्रियाओं को सरल बनाने की दृष्टि से शुरुआत की।',
      journey2Year: '2014',
      journey2Title: 'विस्तार',
      journey2Desc: '50+ बैंकिंग भागीदारों के साथ 5 प्रमुख शहरों में विस्तार किया।',
      journey3Year: '2018',
      journey3Title: 'डिजिटल परिवर्तन',
      journey3Desc: 'हमारे डिजिटल प्लेटफॉर्म का शुभारंभ किया, मासिक 1000+ ग्राहकों को सेवा प्रदान की।',
      journey4Year: '2022',
      journey4Title: 'राष्ट्रीय उपस्थिति',
      journey4Desc: '250+ बैंकिंग भागीदारों के साथ भारत के 4000+ शहरों को कवर किया।',
      journey5Year: '2024',
      journey5Title: 'बाजार नेतृत्व',
      journey5Desc: 'भारत के सबसे तेजी से बढ़ते वित्तीय सेवा प्लेटफॉर्म बन गए।',

      achievementsTitle: 'हमारी उपलब्धियां',
      achievement1Title: '50000+',
      achievement1Desc: 'संतुष्ट ग्राहक',
      achievement2Title: '250+',
      achievement2Desc: 'बैंकिंग भागीदार',
      achievement3Title: '28+',
      achievement3Desc: 'वर्ष संयुक्त अनुभव',
      achievement4Title: '4000+',
      achievement4Desc: 'शहरों में सेवा प्रदान की',

      leadershipTitle: 'नेतृत्व टीम',
      ceoName: 'श्री राकेश पांचाल',
      ceoRole: 'संस्थापक और सीईओ',
      ceoBio: 'वित्तीय क्षेत्र में 28 से अधिक वर्षों के अनुभव के साथ, श्री पांचाल ने अपने दूरदर्शी नेतृत्व के साथ ऋण वितरण उद्योग में क्रांति ला दी है।',
      ctoName: 'सुश्री प्रिया शर्मा',
      ctoRole: 'मुख्य प्रौद्योगिकी अधिकारी',
      ctoBio: 'फिनटेक नवाचार और सुरक्षित प्लेटफॉर्म विकास में 15+ वर्षों के अनुभव के साथ हमारे डिजिटल परिवर्तन का नेतृत्व कर रही हैं।',
      cfoName: 'श्री अमित वर्मा',
      cfoRole: 'मुख्य वित्तीय अधिकारी',
      cfoBio: 'बैंकिंग और वित्तीय सेवाओं में 20+ वर्षों के अनुभव के साथ वित्तीय प्रबंधन में विशेषज्ञ।',

      whyChooseTitle: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज क्यों चुनें?',
      reason1Title: 'विस्तृत नेटवर्क',
      reason1Desc: 'भारत भर के 250+ बैंकों और एनबीएफसी तक पहुंच।',
      reason2Title: 'सर्वोत्तम दरें',
      reason2Desc: 'हमारे साझेदार नेटवर्क के माध्यम से गारंटीकृत सर्वोत्तम ब्याज दरें।',
      reason3Title: 'तेज प्रसंस्करण',
      reason3Desc: '24-72 घंटों के भीतर त्वरित ऋण अनुमोदन और वितरण।',
      reason4Title: 'डिजिटल अनुभव',
      reason4Desc: 'आवेदन से लेकर भुगतान तक की पूरी डिजिटल यात्रा।',
      reason5Title: 'विशेषज्ञ मार्गदर्शन',
      reason5Desc: 'व्यक्तिगत सहायता के लिए समर्पित संबंध प्रबंधक।',
      reason6Title: 'पारदर्शी प्रक्रिया',
      reason6Desc: 'कोई छुपे शुल्क नहीं, पूरी फीस खुलासा अग्रिम में।',

      footerAbout: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज',
      footerDescription: "भारत का अग्रणी वित्तीय सेवा प्लेटफॉर्म, ग्राहकों को लोन, क्रेडिट कार्ड, बीमा और निवेश उत्पादों के लिए 100+ बैंकिंग भागीदारों से जोड़ता है।",
      footerProducts: "ऋण उत्पाद",
      footerHome: "होम लोन",
      footerPersonal: "पर्सनल लोन",
      footerBusiness: "बिजनेस लोन",
      footerLap: "प्रॉपर्टी के खिलाफ लोन",
      footerCar: "कार लोन",
      footerEducation: "शिक्षा ऋण",
      footerServices: "अन्य सेवाएं",
      footerCredit: "क्रेडिट कार्ड",
      footerInsurance: "बीमा",
      footerGold: "गोल्ड लोन",
      footerBills: "बिल भुगतान",
      footerCreditScore: "मुफ्त क्रेडिट स्कोर",
      footerPartner: "भागीदार बनें",
      footerContact: "हमसे संपर्क करें",
      footerPhone: "9909002220",
      footerEmail: "krishnafinconcept09@gmail.com",
      footerAddress: "भारत के 4,000+ शहरों में उपलब्ध",
      footerTiming: "सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6",
      copyrightText: "© 2025 कृष्णा फिनकॉन्सेप्ट सर्विसेज फाइनेंशियल सर्विसेज। सभी अधिकार सुरक्षित।",
      privacyLink: "गोपनीयता नीति",
      termsLink: "नियम एवं शर्तें",
      disclaimerLink: "डिस्क्लेमर"
    },
    gujarati: {
      // Header
      logo: 'ફિનલિંક',
      navHome: 'હોમ',
      navServices: "સેવાઓ",
      navAbout: 'અમારા વિશે',
      navDsa: 'ભાગીદાર બનો',
      navFaq: 'પ્રશ્નો-જવાબો',
      navContact: 'સંપર્ક કરો',
      navCareer: 'કારકિર્દી અમારી સાથે',
      navHelp: 'હેલ્પ ડેસ્ક',
      partnerButton: 'લૉગિન',
      applyButton: 'DSA બની જાઓ',

      // Page Content
      pageTitle: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ વિશે',
      heroTitle: "ભારતની અગ્રણી લોન અને નાણાકીય સેવા પ્લેટફોર્મ",
      heroSubtitle: "નાણાકીય ઉકેલો દ્વારા સપનાઓને સશક્ત બનાવવા",

      missionTitle: 'અમારું મિશન',
      missionContent: 'ટેકનોલોજીનો લાભ લઈને, પ્રક્રિયાઓને સરળ બનાવીને અને અમારા ગ્રાહકો અને ભાગીદારો સાથે ટકાઉ સંબંધો બનાવીને નાણાકીય સેવાઓની ઍક્સેસને લોકશાહી બનાવવું.',

      visionTitle: 'અમારી દ્રષ્ટિ',
      visionContent: 'નવીન ઉકેલો દ્વારા નાણાકીય સ્વતંત્રતા અને સમૃદ્ધિને સક્ષમ કરીને દરેક ભારતીય માટે સૌથી વિશ્વસનીય નાણાકીય ભાગીદાર બનવું.',

      valuesTitle: 'અમારા મૂલ્યો',
      value1Title: 'ગ્રાહક પ્રથમ',
      value1Desc: 'અમે અમારા ગ્રાહકોને બધી વસ્તુઓની મધ્યમાં મૂકીએ છીએ, તેમની નાણાકીય જરૂરિયાતો સચ્ચાઈ અને શ્રેષ્ઠતા સાથે પૂરી કરવાની ખાતરી કરીએ છીએ.',
      value2Title: 'નવીનતા આધારિત',
      value2Desc: 'અત્યાધુનિક નાણાકીય ઉકેલો પ્રદાન કરવા માટે અમારી ટેકનોલોજી અને પ્રક્રિયાઓનો સતત વિકાસ.',
      value3Title: 'પારદર્શિતા',
      value3Desc: 'સ્પષ્ટ સંચાર, ઇમાનદારીની ડીલિંગ અને અમારા તમામ ઓપરેશન્સમાં સંપૂર્ણ પારદર્શિતા.',
      value4Title: 'ભાગીદારી',
      value4Desc: 'પરસ્પર વિકાસ માટે બેંકો, નાણાકીય સંસ્થાઓ અને ડીએસએ ભાગીદારો સાથે મજબૂત સંબંધો બનાવવા.',
      value5Title: 'શ્રેષ્ઠતા',
      value5Desc: 'અમે જે પણ સેવા આપીએ છીએ તેમાં પૂર્ણતા માટે પ્રયત્નશીલ, નાણાકીય ઉદ્યોગમાં નવા ધોરણો સ્થાપિત કરવા.',
      value6Title: 'સામાજિક જવાબદારી',
      value6Desc: 'જનસંખ્યાના તમામ વર્ગો માટે નાણાકીય સેવાઓને સુલભ બનાવીને સમાજમાં યોગદાન આપવું.',

      journeyTitle: 'અમારી યાત્રા',
      journey1Year: '2010',
      journey1Title: 'સ્થાપના',
      journey1Desc: 'સામાન્ય લોકો માટે લોન પ્રક્રિયાઓને સરળ બનાવવાની દ્રષ્ટિ સાથે શરૂઆત કરી.',
      journey2Year: '2014',
      journey2Title: 'વિસ્તરણ',
      journey2Desc: '50+ બેંકિંગ ભાગીદારો સાથે 5 મુખ્ય શહેરોમાં વિસ્તરણ કર્યું.',
      journey3Year: '2018',
      journey3Title: 'ડિજિટલ પરિવર્તન',
      journey3Desc: 'અમારા ડિજિટલ પ્લેટફોર્મ લોન્ચ કર્યું, માસિક 1000+ ગ્રાહકોને સેવા પ્રદાન કરી.',
      journey4Year: '2022',
      journey4Title: 'રાષ્ટ્રીય હાજરી',
      journey4Desc: '250+ બેંકિંગ ભાગીદારો સાથે ભારતના 4000+ શહેરોને આવરી લીધા.',
      journey5Year: '2024',
      journey5Title: 'માર્કેટ લીડરશિપ',
      journey5Desc: 'ભારતના સૌથી ઝડપી વધતા નાણાકીય સેવા પ્લેટફોર્મ બની ગયા.',

      achievementsTitle: 'અમારી સિદ્ધિઓ',
      achievement1Title: '50000+',
      achievement1Desc: 'સંતુષ્ટ ગ્રાહકો',
      achievement2Title: '250+',
      achievement2Desc: 'બેંકિંગ ભાગીદારો',
      achievement3Title: '28+',
      achievement3Desc: 'વર્ષ સંયુક્ત અનુભવ',
      achievement4Title: '4000+',
      achievement4Desc: 'શહેરોમાં સેવા આપી',

      leadershipTitle: 'લીડરશિપ ટીમ',
      ceoName: 'શ્રી રાકેશ પંચાલ',
      ceoRole: 'સ્થાપક અને સીઈઓ',
      ceoBio: 'નાણાકીય ક્ષેત્રમાં 28+ વર્ષના અનુભવ સાથે, શ્રી પંચાલે તેમની દૂરદર્શી નેતૃત્વ સાથે લોન વિતરણ ઉદ્યોગમાં ક્રાંતિ લાવી છે.',
      ctoName: 'સુશ્રી પ્રિયા શર્મા',
      ctoRole: 'મુખ્ય ટેકનોલોજી અધિકારી',
      ctoBio: 'ફિનટેક નવીનતા અને સુરક્ષિત પ્લેટફોર્મ વિકાસમાં 15+ વર્ષના અનુભવ સાથે અમારા ડિજિટલ પરિવર્તનનું નેતૃત્વ કરી રહ્યા છે.',
      cfoName: 'શ્રી અમિત વર્મા',
      cfoRole: 'મુખ્ય નાણાં અધિકારી',
      cfoBio: 'બેંકિંગ અને નાણાકીય સેવાઓમાં 20+ વર્ષના અનુભવ સાથે નાણાકીય વ્યવસ્થાપનમાં નિષ્ણાત.',

      whyChooseTitle: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ કેમ પસંદ કરો?',
      reason1Title: 'વ્યાપક નેટવર્ક',
      reason1Desc: 'ભારત ભરની 250+ બેંકો અને એનબીએફસીની ઍક્સેસ.',
      reason2Title: 'શ્રેષ્ઠ દરો',
      reason2Desc: 'અમારા પાર્ટનર નેટવર્ક દ્વારા ગેરંટીડ શ્રેષ્ઠ વ્યાજ દરો.',
      reason3Title: 'ઝડપી પ્રોસેસિંગ',
      reason3Desc: '24-72 કલાકમાં ઝડપી લોન મંજૂરી અને ચુકવણી.',
      reason4Title: 'ડિજિટલ અનુભવ',
      reason4Desc: 'એપ્લિકેશનથી ચુકવણી સુધીની સંપૂર્ણ ડિજિટલ યાત્રા.',
      reason5Title: 'નિષ્ણાત માર્ગદર્શન',
      reason5Desc: 'વ્યક્તિગત સહાય માટે સમર્પિત સંબંધ મેનેજરો.',
      reason6Title: 'પારદર્શી પ્રક્રિયા',
      reason6Desc: 'કોઈ છુપા શુલ્ક નથી, પૂર્ણ ફી ડિસ્ક્લોઝર અગાઉથી.',

      footerAbout: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ',
      footerDescription: "ભારતનું અગ્રણી નાણાકીય સેવા પ્લેટફોર્મ, ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ, બીમા અને રોકાણ ઉત્પાદનો માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે.",
      footerProducts: "લોન ઉત્પાદનો",
      footerHome: "હોમ લોન",
      footerPersonal: "પર્સનલ લોન",
      footerBusiness: "બિઝનેસ લોન",
      footerLap: "મિલકત સામે લોન",
      footerCar: "કાર લોન",
      footerEducation: "એજ્યુકેશન લોન",
      footerServices: "અન્ય સેવાઓ",
      footerCredit: "ક્રેડિટ કાર્ડ",
      footerInsurance: "બીમા",
      footerGold: "ગોલ્ડ લોન",
      footerBills: "બિલ પેમેન્ટ",
      footerCreditScore: "મફત ક્રેડિટ સ્કોર",
      footerPartner: "ભાગીદાર બનો",
      footerContact: "અમારો સંપર્ક કરો",
      footerPhone: "9909002220",
      footerEmail: "krishnafinconcept09@gmail.com",
      footerAddress: "ભારતના 4,000+ શહેરોમાં ઉપલબ્ધ",
      footerTiming: "સોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6",
      copyrightText: "© 2025 કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ નાણાકીય સેવાઓ. બધા હક્કો આરક્ષિત.",
      privacyLink: "ગોપનીયતા નીતિ",
      termsLink: "નિયમો અને શરતો",
      disclaimerLink: "નિરાકરણ"
    }
  };

  const t = translations[currentLanguage];

  return (
    <>
      {/* New Hero Section as per image */}
      <section className="about-hero-new">
        <div className="about-hero-container">
          <div className="about-hero-left">
            <h1 className="about-hero-heading">Who Are We?</h1>
            <h2 className="about-hero-subheading">INDIA'S LEADING LOAN DISTRIBUTION CHANNEL COMPANY</h2>
            <div className="about-hero-brand">
              <div className="brand-name">Krishna Finconcept Services</div>
              <div className="brand-tagline">Your one-stop shop for comprehensive financial solutions.</div>
            </div>
          </div>
          <div className="about-hero-right">
            <div className="hero-features-horizontal">
              <div className="hero-feature">
                <div className="feature-icon">🏠</div>
                <h3 className="feature-title">Service Offered</h3>
                <p className="feature-desc">Home Loans, Personal Loans Credit Cards, Business Loans Balance Transfers And More.</p>
              </div>
              <div className="hero-feature">
                <div className="feature-icon">🗺️</div>
                <h3 className="feature-title">Nationwide Reach</h3>
                <p className="feature-desc">Serving clients in 4,000+ cities through a wide branch network.</p>
              </div>
              <div className="hero-feature">
                <div className="feature-icon">👨‍💼</div>
                <h3 className="feature-title">Expertise</h3>
                <p className="feature-desc">Founded by financial professionals with 25+ years of experience.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="about-section mission-vision-section">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="card-icon">🎯</div>
              <h3>{t.missionTitle}</h3>
              <p>{t.missionContent}</p>
            </div>
            <div className="vision-card">
              <div className="card-icon">👁️</div>
              <h3>{t.visionTitle}</h3>
              <p>{t.visionContent}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-section values-section">
        <div className="container">
          <h2 className="section-title">{t.valuesTitle}</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">❤️</div>
              <h4>{t.value1Title}</h4>
              <p>{t.value1Desc}</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🚀</div>
              <h4>{t.value2Title}</h4>
              <p>{t.value2Desc}</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔍</div>
              <h4>{t.value3Title}</h4>
              <p>{t.value3Desc}</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h4>{t.value4Title}</h4>
              <p>{t.value4Desc}</p>
            </div>
            <div className="value-card">
              <div className="value-icon">⭐</div>
              <h4>{t.value5Title}</h4>
              <p>{t.value5Desc}</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌍</div>
              <h4>{t.value6Title}</h4>
              <p>{t.value6Desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Timeline */}
      <section className="about-section journey-section">
        <div className="container">
          <h2 className="section-title">{t.journeyTitle}</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">{t.journey1Year}</div>
              <div className="timeline-content">
                <h4>{t.journey1Title}</h4>
                <p>{t.journey1Desc}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t.journey2Year}</div>
              <div className="timeline-content">
                <h4>{t.journey2Title}</h4>
                <p>{t.journey2Desc}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t.journey3Year}</div>
              <div className="timeline-content">
                <h4>{t.journey3Title}</h4>
                <p>{t.journey3Desc}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t.journey4Year}</div>
              <div className="timeline-content">
                <h4>{t.journey4Title}</h4>
                <p>{t.journey4Desc}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">{t.journey5Year}</div>
              <div className="timeline-content">
                <h4>{t.journey5Title}</h4>
                <p>{t.journey5Desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="about-section leadership-section">
        <div className="container">
          <h2 className="section-title">{t.leadershipTitle}</h2>
          <div className="leadership-grid">
            <div className="leader-card">
              <div className="leader-image">👨‍💼</div>
              <h3>{t.ceoName}</h3>
              <p className="leader-role">{t.ceoRole}</p>
              <p className="leader-bio">{t.ceoBio}</p>
            </div>
            <div className="leader-card">
              <div className="leader-image">👩‍💻</div>
              <h3>{t.ctoName}</h3>
              <p className="leader-role">{t.ctoRole}</p>
              <p className="leader-bio">{t.ctoBio}</p>
            </div>
            <div className="leader-card">
              <div className="leader-image">👨‍💼</div>
              <h3>{t.cfoName}</h3>
              <p className="leader-role">{t.cfoRole}</p>
              <p className="leader-bio">{t.cfoBio}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-section why-choose-section">
        <div className="container">
          <h2 className="section-title">{t.whyChooseTitle}</h2>
          <div className="reasons-grid">
            <div className="reason-card">
              <div className="reason-icon">🌐</div>
              <h4>{t.reason1Title}</h4>
              <p>{t.reason1Desc}</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">💰</div>
              <h4>{t.reason2Title}</h4>
              <p>{t.reason2Desc}</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">⚡</div>
              <h4>{t.reason3Title}</h4>
              <p>{t.reason3Desc}</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">📱</div>
              <h4>{t.reason4Title}</h4>
              <p>{t.reason4Desc}</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">👨‍💼</div>
              <h4>{t.reason5Title}</h4>
              <p>{t.reason5Desc}</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">🔍</div>
              <h4>{t.reason6Title}</h4>
              <p>{t.reason6Desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - Same as Home Page */}
      {/* <footer>
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t.footerAbout}</h4>
            <p>{t.footerDescription}</p>
            <div className="social-icons">
              <button className="social-icon">f</button>
              <button className="social-icon">t</button>
              <button className="social-icon">in</button>
              <button className="social-icon">ig</button>
            </div>
          </div>
          <div className="footer-section">
            <h4>{t.footerProducts}</h4>
            <ul className="footer-links">
              <li><button className="footer-link">{t.footerHome}</button></li>
              <li><button className="footer-link">{t.footerPersonal}</button></li>
              <li><button className="footer-link">{t.footerBusiness}</button></li>
              <li><button className="footer-link">{t.footerLap}</button></li>
              <li><button className="footer-link">{t.footerCar}</button></li>
              <li><button className="footer-link">{t.footerEducation}</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t.footerServices}</h4>
            <ul className="footer-links">
              <li><button className="footer-link">{t.footerCredit}</button></li>
              <li><button className="footer-link">{t.footerInsurance}</button></li>
              <li><button className="footer-link">{t.footerGold}</button></li>
              <li><button className="footer-link">{t.footerBills}</button></li>
              <li><button className="footer-link">{t.footerCreditScore}</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><button className="footer-link">{t.footerPartner}</button></li>
              <li><button className="footer-link">{t.footerContact}</button></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.
        </div>
      </footer> */}
    </>
  );
};

export default About;